import React from "react";
import { Link } from "react-router-dom";

const ChildSafety = () => {
  return (
    <div className="content">
      <h2>
        <Link to="/">Home</Link> / Child Safety & Protection Policy
      </h2>
      <br />

      <p align="center">
        <b>ShareMy Child Safety & Protection Policy</b>
      </p>

      <p>
        At ShareMy, we are committed to maintaining a safe and respectful
        environment for all users. We have a zero-tolerance policy for any
        content that sexualizes, exploits, or endangers children—whether real or
        fictional (including digital images, media, text, AI-generated content,
        and illustrations).
      </p>

      <p>
        <b>1. Strictly Prohibited Content & Behavior</b>
      </p>

      <p>
        <b>Child Sexual Exploitation (CSE) & Abuse</b>
      </p>
      <ul>
        <li>
          Any visual depiction or explicit discussion involving the
          sexualization, abuse, or exploitation of children is strictly
          forbidden.
        </li>
        <li>
          This includes the creation, sharing, storing, or solicitation of child
          sexual abuse material (CSAM), even if intended to raise awareness or
          express outrage.
        </li>
        <li>
          Violations will result in immediate removal from ShareMy and reporting
          to law enforcement authorities.
        </li>
      </ul>

      <p>
        <b>Inappropriate Images of Minors</b>
      </p>
      <ul>
        <li>
          Any photos, illustrations, or media featuring children must be
          appropriate and lawful.
        </li>
        <li>
          Children must be fully clothed and cannot appear alone in profile
          photos.
        </li>
        <li>
          We do not allow images of babies, toddlers, or children's genitalia or
          buttocks, even if partially covered or obscured by emojis.
        </li>
      </ul>

      <p>
        <b>Child Grooming & Endangerment</b>
      </p>
      <ul>
        <li>
          Any attempt to coerce, manipulate, or entice minors into inappropriate
          conversations, relationships, or behaviors is a serious offense and
          will be reported.
        </li>
      </ul>

      <p>
        <b>2. Enforcement & Reporting</b>
      </p>

      <p>
        <b>Automatic Account Removal & Law Enforcement Reporting</b>
      </p>
      <ul>
        <li>
          If we detect or are made aware of any child exploitation, grooming, or
          abuse, we will immediately remove the content, ban the account, and
          report it to the National Center for Missing & Exploited Children
          (NCMEC) and relevant authorities.
        </li>
        <li>
          NCMEC may escalate the case to global law enforcement agencies as
          necessary.
        </li>
      </ul>

      <p>
        <b>Appeals & Mistaken Actions</b>
      </p>
      <ul>
        <li>
          If you believe your account or content was removed in error, you may
          contact us for an appeal.
        </li>
        <li>
          However, ShareMy prioritizes child safety above all else, and
          violations will be treated with the utmost seriousness.
        </li>
      </ul>

      <p>
        <b>3. Creating a Safe Community Together</b>
      </p>
      <p>
        ShareMy is designed for adults aged 18 and older. We encourage all users
        to report any concerns related to child safety. If you come across
        suspicious activity, please report it immediately through our in-app
        reporting tools or by contacting us at{" "}
        <a href="mailto:support@sharemy.com">support@sharemy.com</a>.
      </p>
      <p>
        Protecting children is everyone's responsibility. Thank you for helping
        us keep ShareMy a safe and respectful platform.
      </p>

      <p>
        <b>4. Relationship to the Terms</b>
      </p>
      <p>
        This Policy supplements the <Link to="/terms-of-use">Terms of Use</Link>{" "}
        and <Link to="/community-guide">Community Guidelines</Link>.
      </p>
    </div>
  );
};

export default ChildSafety;
